import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import isString from 'lodash.isstring';
import isEmpty from 'lodash.isempty';

import { short } from '../common/formatting/date';

const showQuestion = (question, responses) => {
	const questionResponses = responses.filter(response => response.care_quest_questionId === question.id);
	return questionResponses.length > 0;
};

const getAnswer = (question, responses) => {
	const qResponses = responses.filter(response => response.care_quest_questionId === question.id);
	const [response] = qResponses;
	if (question.question_type.indexOf('Multiple Select') >= 0) {
		return qResponses.map(response => {
			const answer = question.care_quest_answers.find(answer => answer.id === response.care_quest_answerId);
			return (
				<p key={response.id} className={cn({ 'negative-sentiment': answer.sentiment === 'Negative' })}>
					{answer.answer_text}
				</p>
			);
		});
	}
	if (response && isString(response.care_quest_answer_text)) {
		if (question.question_type === 'Date') {
			return (
				<p>{short(response.care_quest_answer_text)}</p>
			);
		}
		if (isEmpty(response.care_quest_answer_text.trim())) {
			return (<p><em>NO RESPONSE</em></p>);
		} else {
			return (<p>{response.care_quest_answer_text}</p>);
		}
	} else if (response && response.care_quest_answerId) {
		const answer = question.care_quest_answers.find(answer => answer.id === response.care_quest_answerId);
		if (answer) {
			return (
				<p className={cn({ 'negative-sentiment': answer.sentiment === 'Negative' })}>
					{answer.answer_text}
				</p>
			);
		}
	}
};

const Questionnaire = ({ questions, responses }) => {
	if (questions && responses) {
		return (
			<ol>
				{questions.map(question => (
					question.conditional_parent_question_id ? (
						showQuestion(question, responses) && (
							<ul key={question.id}>
								<li>
									<strong>{question.question_text}</strong><br />
									{getAnswer(question, responses)}
								</li>
							</ul>
						)
					) : (
						<li key={question.id}>
							<strong>{question.question_text}</strong><br />
							{getAnswer(question, responses)}
						</li>
					)
				))}
			</ol>
		);
	}
	return null;
};

Questionnaire.propTypes = {
	questions: PropTypes.array,
	responses: PropTypes.array
};

export default Questionnaire;
